import { IObject } from "../../../shared/utils/utils";

interface IEventConsolidationInfo {
  primary_datetime_column_id: string;
  process_type_column_id: string;
}

export function transformToBackendEventConsolidationInfo(data: IEventConsolidationInfo) {
  return {
    primary_datetime_column_id: data.primary_datetime_column_id,
    process_type_column_id: data.process_type_column_id
  };
}

export function transformFromBackendEventConsolidationInfo(backendType: IObject) {
  return {
    primary_datetime_column_id: backendType.primary_datetime_column_id,
    process_type_column_id: backendType.process_type_column_id,
    primary_datetime_column: backendType.primary_datetime_column_name,
    process_type_column: backendType.process_type_column_name,
    primary_datetime_column_db_name: backendType.primary_datetime_column_db_name
  };
}
